import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Paper,
  Typography,
  Container,
  Grid,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ValidatedTextInput } from 'components/ValidatedTextInput';
import logo from 'static/media/logo2x.png';
import 'translations/translations';
import { ApiService } from 'services/apiService';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: '8%',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '25rem',
    margin: 'auto',
    padding: '1.8rem 3.125rem',
  },
  img: {
    maxWidth: '18rem',
    marginBottom: '2rem',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(6, 0, 1, 0),
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    color: '#fff',
    fontWeight: 'bold',
  },
  error: {
    color: theme.palette.error.main,
    textAlign: 'right',
    fontSize: '0.8rem',
  },
  alignRight: {
    textAlign: 'right',
  },
  alignCenter: {
    textAlign: 'center',
  },
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const [isDisabled, setIsDisabeld] = useState(true);
  const [confirmationSuccess, setConfirmationSuccess] = useState<
    boolean | null
  >(null);
  const [error, setError] = useState(false);

  const [username, setUsername] = useState('');

  const { t } = useTranslation(['translations']);

  useEffect(() => {
    if (username) {
      setIsDisabeld(false);
    } else {
      setIsDisabeld(true);
    }
  }, [username]);

  const handleChange = (name: string, value: string) => {
    setUsername(value);
  };

  const handleSubmit = () => {
    if (username) {
      setConfirmationSuccess(false);
      ApiService.forgotPassword(username)
        .then(() => {
          setConfirmationSuccess(true);
        })
        .catch(() => {
          setConfirmationSuccess(null);
          setError(true);
        });
    }
  };

  return (
    <Container className={classes.container}>
      <Paper className={classes.paper}>
        <img src={logo} alt="Logo" className={classes.img} />
        {confirmationSuccess ? (
          <div>{t('reset_password_page.request_success')}</div>
        ) : confirmationSuccess === false ? (
          <CircularProgress color="secondary" />
        ) : (
          <div className={classes.form}>
            <ValidatedTextInput
              type="email"
              required={true}
              label={t('login_page.email')}
              handleChangeCallback={handleChange}
              inputName="username"
              autoFocus={true}
            />
            <Typography className={classes.error}>
              {error && t('reset_password_page.request_failed')}
            </Typography>
            <Grid container>
              <Grid item xs={12} className={classes.alignCenter}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  disabled={isDisabled}
                >
                  {t('reset_password_page.request_change')}
                </Button>
              </Grid>
            </Grid>
          </div>
        )}
      </Paper>
    </Container>
  );
};

export { ForgotPassword };
